// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../../services/configuration.service';

@Component({
  selector: 'app-gallery-card',
  standalone: false,
  templateUrl: './gallery-card.component.html',
  styleUrl: './gallery-card.component.css'
})
export class GalleryCardComponent implements OnInit {
  defaultGalleryImageUrl = "assets/images/house-warming-collage.png"
  galleryImageUrl: string | null = null;

  constructor(private configurationService: ConfigurationService) {}

  ngOnInit(): void {
    this.configurationService.getConfiguration().subscribe(config => {
      this.galleryImageUrl = config?.galleryImageUrl || this.defaultGalleryImageUrl;
    });
  }
}
